// Muestra de color a partir del nombre que trae el producto (los colores del catálogo están en español).
const COLORS: Record<string, string> = {
  negro: '#16161a', black: '#16161a', blanco: '#fbfbf8', white: '#fbfbf8', arena: '#d9c7a5', beige: '#e3d5b8', khaky: '#b7a57a', khaki: '#b7a57a', kaki: '#b7a57a',
  camel: '#b98a55', chocolate: '#4a2f23', cafe: '#6b4a35', marron: '#6b4a35', gris: '#8e9196', gray: '#8e9196', rojo: '#c0392b', red: '#c0392b', vino: '#6d1f2c', vinotinto: '#6d1f2c',
  rosado: '#eaa9b8', rosa: '#eaa9b8', pink: '#eaa9b8', fucsia: '#c2337f', lila: '#b9a4d8', morado: '#6b4a9c', purple: '#6b4a9c', azul: '#2f5fb3', blue: '#2f5fb3', celeste: '#9cc7e8',
  verde: '#2f8f5b', green: '#2f8f5b', menta: '#a9dcc3', oliva: '#6f7442', militar: '#545c3a', botella: '#1f4d3a', amarillo: '#e8c53a', yellow: '#e8c53a', mostaza: '#c9972b',
  mandarina: '#ef8b3a', naranja: '#ef8b3a', orange: '#ef8b3a', terracota: '#b5583a', hueso: '#efe8d8', marfil: '#efe8d8', crema: '#f1e6c9', dorado: '#c9a54a', plata: '#c4c7cc',
};

const norm = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Color de la muestra para un nombre como "Verde menta" o "Suplex mickey Lila"; null si no se reconoce ninguna palabra. */
export function swatchColor(name: string | null | undefined): string | null {
  if (!name) return null;
  const words = norm(name).split(/[^a-z]+/).filter(Boolean);
  for (const w of [...words].reverse()) if (COLORS[w]) return COLORS[w]!; // la última palabra suele ser el matiz ("verde menta")
  return null;
}
